import { Transaction } from '../abstract/transaction.model';
import { CardReceiptAllocation } from './card-receipt-allocation.model';
import { PaymentProvider } from './payment-provider.model';

export class CardReceipt extends Transaction {

    static override CLASS_NAME: string = 'CardReceipt';

    private _paymentProvider!: PaymentProvider;
    private _number!: string;

    public get allocations(): CardReceiptAllocation[] {
        return this._allocations as CardReceiptAllocation[];
    }

    public set allocations(value: any) {
        this._setValue('_allocations', value, 'CardReceiptAllocation');
    }

    public get number(): string {
        return this._number;
    }

    public set number(value: any) {
        this._setValue('_number', value, 'string');
    }

    public get paymentProvider(): PaymentProvider {
        return this._paymentProvider;
    }

    public set paymentProvider(value: any) {
        this._setValue('_paymentProvider', value, 'PaymentProvider');
    }

}
